module.exports = __webpack_public_path__ + "static/media/hover_image_space.f23519e8.png";